import { useSyncExternalStore } from 'react';

const noop = () => undefined;
const noOpSubscribe = () => noop;

export const useClientSnapshot = <T>(getClientSnapshot: () => T, serverSnapshot: T): T =>
  useSyncExternalStore(noOpSubscribe, getClientSnapshot, () => serverSnapshot);
